"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, SunDim } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { flushSync } from "react-dom";
import { cn } from "@/shared/lib/utils";
import { useTheme } from "next-themes";
type props = {
  className?: string;
};
export const AnimatedThemeToggler = t0 => {
  const $ = _c(14);
  const {
    className
  } = t0;
  const {
    theme,
    setTheme
  } = useTheme();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] !== theme) {
    t1 = () => {
      setMounted(true);
      setIsDarkMode(theme === "dark");
    };
    t2 = [theme];
    $[0] = theme;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const buttonRef = useRef(null);
  let t3;
  if ($[3] !== setTheme) {
    t3 = async () => {
      if (!buttonRef.current) {
        return;
      }
      await document.startViewTransition(() => {
        flushSync(() => {
          const dark = document.documentElement.classList.toggle("dark");
          setTheme(dark ? "dark" : "light");
          setIsDarkMode(dark);
        });
      }).ready;
      const {
        top,
        left,
        width,
        height
      } = buttonRef.current.getBoundingClientRect();
      const y = top + height / 2;
      const x = left + width / 2;
      const right = window.innerWidth - left;
      const bottom = window.innerHeight - top;
      const maxRad = Math.hypot(Math.max(left, right), Math.max(top, bottom));
      document.documentElement.animate({
        clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${maxRad}px at ${x}px ${y}px)`]
      }, {
        duration: 700,
        easing: "ease-in-out",
        pseudoElement: "::view-transition-new(root)"
      });
    };
    $[3] = setTheme;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const changeTheme = t3;
  if (!mounted) {
    return null;
  }
  let t4;
  if ($[5] !== className) {
    t4 = cn(className);
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isDarkMode ? "Switch to light mode" : "Switch to dark mode";
  let t6;
  if ($[7] !== isDarkMode) {
    t6 = isDarkMode ? <SunDim /> : <Moon />;
    $[7] = isDarkMode;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== changeTheme || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <button ref={buttonRef} onClick={changeTheme} className={t4} aria-label={t5}>{t6}</button>;
    $[9] = changeTheme;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};